export default __webpack_public_path__ + "static/media/teamIcon.f520a169.svg";